<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-150 ease-out"
      enter-from-class="opacity-0 translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-1"
    >
      <div
        v-if="hoveredCitation"
        class="z-[200] w-80 overflow-hidden rounded-xl border border-gray-200 bg-white
          shadow-[0_8px_12px_rgba(0,0,0,0.08),0_4px_8px_rgba(0,0,0,0.08)]"
        :style="popoverStyle"
        @mouseenter="emit('keep-open')"
        @mouseleave="emit('schedule-hide')"
      >
        <div class="space-y-1.5 px-4 pb-3 pt-4">
          <p class="text-base font-semibold text-gray-900">
            {{ resolveCourtName(t, hoveredCitation.verdict.court) }}
          </p>
          <p
            v-if="hoveredCitation.verdict.date || hoveredCitation.verdict.file_number"
            class="text-xs text-gray-500"
          >
            {{
              [
                hoveredCitation.verdict.date
                  ? `${t('VerdictUrteilVom')} ${hoveredCitation.verdict.date}`
                  : '',
                hoveredCitation.verdict.file_number
              ]
                .filter(Boolean)
                .join(' – ')
            }}
          </p>
        </div>
        <div class="relative px-4 pb-4">
          <p class="line-clamp-5 text-sm italic text-gray-700">
            {{ hoveredCitation.verdict.excerpt }}
          </p>
          <div
            class="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent"
          />
        </div>
        <div class="px-4 pb-4">
          <button
            class="text-sm font-medium text-gray-900 underline hover:no-underline"
            @click="emit('open-pdf', hoveredCitation!.verdict.court_judgement_uuid)"
          >
            {{ t('VerdictReadMore') }}
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
  import type { CSSProperties } from 'vue'
  import { useTranslation } from '@/composables/useTranslation'
  import { resolveCourtName, verdictLabelTranslations } from '@/composables/useVerdictLabels'
  import type { VerdictChunk } from '@/composables/useVerdictChunks'

  defineProps<{
    hoveredCitation: { verdict: VerdictChunk; rect: DOMRect } | null
    popoverStyle: CSSProperties
  }>()

  const emit = defineEmits<{
    'keep-open': []
    'schedule-hide': []
    'open-pdf': [uuid: string]
  }>()

  const { t } = useTranslation({
    en: {
      ...verdictLabelTranslations.en,
      VerdictReadMore: 'Read more'
    },
    de: {
      ...verdictLabelTranslations.de,
      VerdictReadMore: 'Mehr lesen'
    }
  })
</script>
